// @ts-nocheck
/* eslint-disable spire/export-styles */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ThemeTypography } from "@insite/mobius/globals/baseTheme";
import Typography from "@insite/mobius/Typography";
import fieldDefinitionBuilder from "@store/Framework/Features/FieldDefinitionBuilder/fieldDefinitionBuilder";
import { FieldDefinitionBuilderOptions } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import { responsiveCss } from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/responsiveCss";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import { titleBorderFieldDefinitions } from "@store/Overrides/Widgets/Basic/PageTitle";
import { handleTextAlignment } from "@store/Themes/common/mixins/typography";
import pageTitleProps from "@store/Themes/common/props/pageTitle";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    titleType = "titleType",
    titleStyle = "titleStyle",
    titleText = "titleText",
    useCustomSpacing = "useCustomSpacing",
    customSpacing = "customSpacing",
    hasBorder = "hasBorder",
    alignment = "alignment",
    borderColor = "borderColor",
    borderSide = "borderSide",
    useCustomColor = "useCustomColor",
    customColor = "customColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.titleType]: keyof React.ReactHTML;
        [fields.titleStyle]: keyof ThemeTypography | undefined;
        [fields.alignment]: "flex-start" | "center" | "flex-end";
        [fields.borderColor]: string;
        [fields.borderSide]: string;
        [fields.hasBorder]: boolean;
        [fields.titleText]: string;
        [fields.useCustomSpacing]: boolean;
        [fields.customSpacing]: number;
        [fields.useCustomColor]: boolean;
        [fields.customColor]: string;
    } & FieldDefinitionBuilderOptions<"titleStyle" | "titleType" | "customColor">;
}

type Props = WidgetProps & OwnProps;

const Title: React.FunctionComponent<Props> = ({ fields }: Props) => {
    const titleStyles = {
        border: fields.hasBorder
            ? {
                  align: fields.alignment,
                  color: fields.borderColor,
                  side: fields.borderSide,
              }
            : undefined,
        css: css`
            ${pageTitleProps.css}

            ${responsiveCss(
                fields,
                field => css`
                    ${field.useCustomSpacing &&
                    `
                        margin-bottom: ${pxToRem(field.customSpacing)};
                    `}

                    ${field.useCustomColor &&
                    `
                        color: ${field.customColor};
                    `}

                    text-align: ${handleTextAlignment(field.alignment)};
                `,
            )}
        `,
    };

    return (
        <Typography variant={fields.titleStyle} as={fields.titleType} {...titleStyles}>
            {fields.titleText}
        </Typography>
    );
};

const widgetModule: WidgetModule<FoundationFieldDefinition> = {
    component: Title,
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                name: fields.titleText,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: false,
                fieldType: "General",
            },
            ...titleBorderFieldDefinitions,
            ...fieldDefinitionBuilder(
                [
                    {
                        name: fields.useCustomSpacing,
                        displayName: "Use Custom Spacing",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        tooltip: "If not checked, it applies the spacing from base theme",
                        fieldType: "General",
                    },
                    {
                        name: fields.customSpacing,
                        displayName: "Custom Spacing Bottom",
                        editorTemplate: "IntegerField",
                        defaultValue: 0,
                        tooltip: "The Spacing Bottom in Number of Pixels",
                        fieldType: "General",
                        isVisible: widget => widget.fields.useCustomSpacing,
                    },
                ],
                {
                    typographyOptions: {
                        titleStyle: true,
                        titleType: true,
                        useCustomColor: true,
                        customColor: true,
                    },
                },
            ),
        ],
    },
};

export default widgetModule;
